































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { VPopover } from 'v-tooltip'

@Component({
  components: { LoaderWrapper, Icon, VPopover },
  props: {
    uploadAction: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: '*'
    },
    filePath: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    },
    // max file size in KB
    maxSize: {
      type: String || Number,
      default: '10240'
    },
    value: {
      type: String || File,
      default: ''
    },
    hideRemove: {
      type: Boolean,
      default: false
    }
  }
})
export default class InputFileV2 extends Vue {
  isLoading: boolean = false
  isDragOver: boolean = false
  localError: boolean = false
  localFileName: string = ''

  // used if prop value is file and not file name
  base64Img: string = ''

  get isImage () {
    if (!this.$props.value) {
      return false
    }

    let fileName: string = this.$props.value

    if (this.$props.value instanceof File) {
      fileName = this.$props.value.name
    }

    const ext: string[] = ['webp', 'WEBP', 'jpg', 'png', 'svg', 'jpeg', 'JPG', 'JPEG', 'PNG', 'SVG']
    const fileExt: string = (fileName as string).split('.').pop() || ''
    return ext.includes(fileExt)
  }

  get valueIsFile () {
    if (!this.$props.value) {
      return false
    }

    return this.$props.value instanceof File
  }

  async toBase64 (file: File | string) {
    if (this.valueIsFile) {
      this.base64Img = await new Promise(function (resolve, reject) {
        let reader = new FileReader()
        reader.readAsDataURL(file as File)
        // @ts-ignore
        reader.onload = () => resolve(reader.result)
      })
    }
  }

  mounted () {
    this.$watch('$props.value', async (val) => {
      try {
        this.isLoading = true
        await this.toBase64(val)
      } finally {
        this.isLoading = false
      }
    }, { immediate: true })
  }

  focusInput () {
    if (this.$props.disabled || this.isLoading) {
      return
    }

    (this.$refs.fileInput as any).click()
  }

  selectFile () {
    if (this.$props.disabled || this.isLoading) {
      return
    }

    if (!(this.$refs.fileInput as any).files) {
      return
    }

    try {
      if ((this.$refs.fileInput as any).files.length > 1) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          header: 'Denied',
          message: 'Please select one file',
          icon: 'warning'
        })
        throw new Error('Multiple files are forbidden')
      }

      const file = (this.$refs.fileInput as any).files[0]
      this.validateFile(file)
      this.upload(file)
    } catch (e) {
      console.error(e)
    }
  }

  async upload (file: File) {
    if (this.$props.disabled || this.isLoading) {
      return
    }

    this.localFileName = file.name

    try {
      this.isLoading = true
      await this.$props.uploadAction(file)
    } catch (e) {
      console.error('file upload error', e)
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'Error',
        message: 'Something went wrong during file upload',
        icon: 'warning'
      });
      (this.$refs.fileInput as any).value = ''
      this.localFileName = ''
    } finally {
      this.isLoading = false
    }
  }

  validateFile (file: File) {
    if (!file) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'No file chosen',
        icon: 'warning'
      })
      throw new Error('No file chosen')
    }

    if (file.size > 1024 * Number(this.$props.maxSize)) {
      const sizeMb = Number(this.$props.maxSize) / 1024
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `File size exceeded`,
        message: `Max size: ${sizeMb >= 1 ? (sizeMb + 'Mb') : (Number(this.$props.maxSize) + 'Kb')}`,
        icon: 'warning'
      })
      throw new Error('File size exceeded')
    }

    if (this.$props.accept === '*') {
      return
    }

    let types: string[] = this.$props.accept.split(',').map((item: string) => item.trim())
    types = [...types, ...types.map((item: string) => item.toUpperCase())]

    const fileExt = '.' + file.name.split('.').pop()
    const typeValid: boolean = !!types.find((item: string) => item === file.type || item === fileExt)

    if (!typeValid) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `Invalid file type`,
        icon: 'warning'
      })
      throw new Error('Invalid file type')
    }
  }

  onDrop (e: any) {
    if (this.$props.disabled || this.isLoading) {
      return
    }

    this.isDragOver = false

    if (!e.dataTransfer.items) {
      return
    }

    const file = e.dataTransfer.items[0].getAsFile()

    try {
      if (e.dataTransfer.items[0].kind !== 'file') {
        return
      }

      if (e.dataTransfer.items.length > 1) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          header: 'Denied',
          message: 'Please select one file',
          icon: 'warning'
        })
        throw new Error('Multiple files are forbidden')
      }

      this.validateFile(file)
      this.upload(file)
    } catch (e) {
      console.error(e)
    }
  }

  setDrag (val: boolean) {
    if (this.$props.disabled || this.isLoading) {
      return
    }

    this.isDragOver = val
  }

  remove () {
    (this.$refs.fileInput as any).value = ''
    this.localFileName = ''
    this.$emit('remove')
  }
}
